import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cars: [],
};

const carSlice = createSlice({
  name: "Car",
  initialState,
  reducers: {},
});

export const selectCars = (state) => state.car.cars;

export default carSlice.reducer;
